import { render } from "./Default.vue?vue&type=template&id=250750e9"
const script = {}

import "./Default.vue?vue&type=style&index=0&id=250750e9&lang=scss"
script.render = render

export default script